import { Button } from "@mui/material";
import React, { useState } from "react";
import { Offer } from "../interfaces/intefaces";
import { useTranslation } from "../hooks/hooks";
import OfferModal from "./OfferModal";

interface IProps {
    offers: Offer[] | undefined;
}

const Offers = ({ offers }: IProps) => {
    const { _e } = useTranslation();
    const [open, setOpen] = useState(false);
    const [offer, setOffer] = useState<Offer>();
    const handleClick = (offer: Offer) => {
        setOpen(true);
        setOffer(offer);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <div className="offers">
                {offers &&
                    offers.map((offer, index) => {
                        return (
                            <div key={`offer-${index}`} className="offer">
                                <div className="offer-inner">
                                    <img src={offer.banner} alt="offer banner" />
                                    <div className="text-wrapper">
                                        <h2 className="title">{offer.heading}</h2>
                                        <p>{offer.intro_text}</p>
                                        <Button
                                            sx={{
                                                margin: "10px 0",
                                            }}
                                            onClick={() => handleClick(offer)}
                                            variant="outlined"
                                        >
                                            {_e("MORE INFO")}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
            {offer && <OfferModal open={open} offer={offer} onRequestClose={handleClose} />}
        </>
    );
};

export default Offers;
